var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentPayoutDeductionsDetails
    ? _c(
        "vs-modal",
        {
          staticClass: "details",
          attrs: { title: "Payout Info" },
          on: {
            close: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [
          _c(
            "vs-layout",
            {
              attrs: {
                slot: "body",
                "wrap-xs": "wrap-xs",
                "no-gutter": "no-gutter"
              },
              slot: "body"
            },
            [
              _c(
                "vs-layout",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.get(
                        _vm.currentPayoutDeductionsDetails,
                        "payment_method"
                      ),
                      expression:
                        'get(currentPayoutDeductionsDetails, "payment_method")'
                    }
                  ],
                  attrs: {
                    "no-gutter": "no-gutter",
                    sm: "6",
                    lg: "4",
                    "margin-bottom": "1",
                    "wrap-xs": "wrap-xs"
                  }
                },
                [
                  _c("label", { staticClass: "details__label" }, [
                    _vm._v("Payment Mode")
                  ]),
                  _c("h6", { staticClass: "details__value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.get(
                          _vm.currentPayoutDeductionsDetails,
                          "payment_method"
                        )
                      )
                    )
                  ])
                ]
              ),
              _c(
                "vs-layout",
                {
                  attrs: {
                    "no-gutter": "no-gutter",
                    sm: "6",
                    lg: "4",
                    "margin-bottom": "1",
                    "wrap-xs": "wrap-xs"
                  }
                },
                [
                  _c("label", { staticClass: "details__label" }, [
                    _vm._v("Amount")
                  ]),
                  _c("h6", { staticClass: "details__value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.currency(
                          _vm.get(_vm.currentPayoutDeductionsDetails, "amount")
                        )
                      )
                    )
                  ])
                ]
              ),
              _vm._l(
                _vm.get(_vm.currentPayoutDeductionsDetails, "payouts"),
                function(payout, index) {
                  return _c(
                    "vs-layout",
                    {
                      key: index,
                      attrs: { "no-gutter": "no-gutter", "margin-top": "1" }
                    },
                    [
                      _c("deductions-table", {
                        attrs: { deductions: payout.deductions }
                      })
                    ],
                    1
                  )
                }
              )
            ],
            2
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("vs-button", {
                attrs: {
                  type: "button",
                  text: "done",
                  icon: "check",
                  processing: _vm.processing,
                  disabled: _vm.processing
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }